<script setup lang="ts">
import { helpers } from '@vuelidate/validators'
import { useVModel } from '@vueuse/core'

import { Form } from '~/layers/forms/models'

interface Props {
  modelValue: boolean
}

const props = defineProps<Props>()
const emits = defineEmits(['update:modelValue'])
const model = useVModel(props, 'modelValue', emits)

const v$ = useValidation(
  () => ({
    model: {
      accepted: helpers.withMessage(
        'Para continuar es necesario aceptar los terminos y condiciones.',
        () => model.value
      ),
    },
  }),
  { model },
  { $scope: Form.tos, $registerAs: Form.tos }
)
</script>

<template>
  <FormsGlobalContainer :identifier="Form.tos">
    <FormsGlobalTitle
      text="Términos y condiciones"
      icon-class="icon-[ph--book-open-bold]"
    />

    <InputContainer
      class="col-span-full"
      :error="v$.model?.$error"
      :error-message="v$.model?.$errors[0]?.$message.toString()"
    >
      <div class="flex items-center gap-3">
        <PvCheckbox v-model="model" />
        <div class="leading-none">He leído y acepto los terminos y condiciones.</div>
      </div>

      <div
        aria-label="Terminos y condiciones"
        class="self-end icon-[ph--arrow-square-out-bold] text-2xl leading-none"
        @click="navigateTo('/', { external: true, open: { target: '_blank' } })"
      />
    </InputContainer>
  </FormsGlobalContainer>
</template>
